import React from "react";
import PublicLayout from "@/components/PublicLayout";
import { useSiteContent } from "@/context/SiteContentContext";
import { ShieldCheck } from "lucide-react";

const Section = ({ title, children }) => (
  <div className="space-y-2">
    <h2 className="font-heading text-xl font-bold text-white">{title}</h2>
    <div className="text-slate-300 leading-relaxed space-y-2">{children}</div>
  </div>
);

export default function PrivacyPage() {
  const { content } = useSiteContent();
  const g = content.general || {};
  const nome = "Officina Dentale 3D print";
  const email = g.email || "officinadentale.3dprint@gmail.com";
  const indirizzo = g.address || "";
  const aggiornamento = "Luglio 2026";

  return (
    <PublicLayout>
      <section className="pt-32 pb-14 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-3 text-teal-400">
            <ShieldCheck className="h-6 w-6" />
            <p className="text-sm font-bold uppercase tracking-widest">Protezione dei dati</p>
          </div>
          <h1 className="font-heading text-4xl sm:text-5xl font-extrabold mt-3">Informativa sulla Privacy</h1>
          <p className="mt-4 text-slate-300 text-lg">Trattamento dei dati personali ai sensi del Regolamento (UE) 2016/679 (GDPR) e del D.Lgs. 196/2003.</p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10" data-testid="privacy-content">
          <Section title="1. Titolare del trattamento">
            <p><strong>{nome}</strong>{indirizzo ? `, ${indirizzo}` : ""}. Contatto: <a className="text-teal-600 underline" href={`mailto:${email}`}>{email}</a>.</p>
          </Section>

          <Section title="2. Dati trattati">
            <p>Nell'ambito del portale ordini possono essere trattati: dati anagrafici e di fatturazione dello studio/cliente; dati di contatto; file tecnici (STL, XML, immagini, PDF, documenti) e prescrizioni relative alle lavorazioni odontotecniche, che possono contenere riferimenti a pazienti (iniziali o codice caso).</p>
          </Section>

          <Section title="3. Categorie particolari di dati (dati sanitari)">
            <p>I dati relativi ai pazienti sono <strong>categorie particolari</strong> ai sensi dell'art. 9 GDPR. Il cliente (studio dentistico) agisce quale Titolare autonomo nei confronti del paziente ed è tenuto ad acquisire il relativo consenso; il laboratorio tratta tali dati in qualità di Responsabile del trattamento per le sole finalità di realizzazione del dispositivo.</p>
          </Section>

          <Section title="4. Finalità e base giuridica">
            <p>I dati sono trattati per: esecuzione del contratto e realizzazione delle lavorazioni richieste; adempimenti fiscali e di legge; obblighi normativi in materia di dispositivi medici su misura (Reg. UE 2017/745 - MDR). Base giuridica: esecuzione del contratto e obblighi di legge (art. 6 GDPR); per i dati sanitari, art. 9, par. 2, lett. h) GDPR.</p>
          </Section>

          <Section title="5. Conservazione">
            <p>I dati e i file sono conservati per il tempo necessario alle finalità sopra indicate e nel rispetto dei termini di legge (inclusi gli obblighi di documentazione tecnica MDR). Al termine, i dati sono cancellati o resi anonimi.</p>
          </Section>

          <Section title="6. Sicurezza">
            <p>Il portale adotta misure tecniche e organizzative adeguate: connessioni cifrate (HTTPS), controllo degli accessi tramite account e ruoli distinti, tracciamento dei download dei file e archiviazione su infrastruttura cloud.</p>
          </Section>

          <Section title="7. Diritti dell'interessato">
            <p>È possibile esercitare i diritti di accesso, rettifica, cancellazione, limitazione, opposizione e portabilità (artt. 15-22 GDPR) scrivendo a <a className="text-teal-600 underline" href={`mailto:${email}`}>{email}</a>. È inoltre possibile proporre reclamo al Garante per la protezione dei dati personali.</p>
          </Section>

          <p className="text-sm text-slate-400 pt-6 border-t border-white/10">Ultimo aggiornamento: {aggiornamento}. Il presente documento è un modello di base e dovrebbe essere validato dal proprio consulente/DPO prima dell'uso definitivo.</p>
        </div>
      </section>
    </PublicLayout>
  );
}
